import Work from './Work';

export default Work;



// WEBPACK FOOTER //
// ./src/Work/index.js